
import { toast } from '@/hooks/use-toast';
import { ToastActionElement } from '@/components/ui/toast';

/**
 * Show an error toast with consistent styling
 */
export const showErrorToast = (title: string, description: string) => {
  toast({
    title,
    description,
    variant: "destructive",
  });
};

/**
 * Show a success toast with consistent styling
 */
export const showSuccessToast = (title: string, description: string) => {
  toast({
    title,
    description,
  });
};

/**
 * Show an error toast from an error object
 */
export const showUploadErrorToast = (error: Error | unknown, fallbackMessage: string = "Upload failed") => {
  const errorMessage = error instanceof Error ? error.message : fallbackMessage;
  toast({
    title: "Error",
    description: errorMessage,
    variant: "destructive",
  });
};

/**
 * Show a warning toast for storage fallback
 */
export const showStorageFallbackToast = () => {
  toast({
    title: "Storage Fallback",
    description: "Using local storage instead. Your image will be available for this session only.",
    variant: "default",
  });
};

/**
 * Show a success toast for uploads with optional stats
 */
export const showUploadSuccessToast = (stats?: string) => {
  toast({
    title: "Upload Complete",
    description: stats || "Your image has been uploaded successfully.",
  });
};

/**
 * Show a warning toast
 */
export const showWarningToast = (title: string, description: string) => {
  toast({
    title,
    description,
    variant: "default",
  });
};

/**
 * Generic toast helper with options
 */
export const showToast = (
  title: string, 
  description: string, 
  options?: { 
    variant?: "default" | "destructive", 
    action?: ToastActionElement 
  }
) => {
  toast({
    title,
    description,
    variant: options?.variant,
    action: options?.action,
  });
};
